// extracted by mini-css-extract-plugin
module.exports = {"gitalk":"gitalk-module--gitalk--1_fHD"};